import styled from 'styled-components';

import { WHITE, BG_GRAY } from '../../../styles/variables.style';
import media from '../../../styles/media.style';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 500px;

  ${media.tabletL`
    flex-direction: row;
    min-height: auto;
    height: 550px;
  `};
`;

export const ImageWrapper = styled.div`
  height: 126px;
  padding-left: 45px;
  background-color: ${BG_GRAY.COMMON_5};
  max-width: 125px;

  img {
    display: block;
  }

  ${media.tabletL`
    flex: 2;
    height: 100%;
    padding: 0;
    background-color: transparent;
    min-width: 350px;
    max-width: 350px;
  `};
`;

export const Content = styled.div`
  padding: 28px 45px 0 45px;
  background-color: ${WHITE};

  ${media.tabletL`
    flex: 3;
    padding: 3.5em 80px 3.5em 130px;
  `};
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 600;
  text-transform: uppercase;

  ${media.tabletL`
    font-size: 38px;
  `};
`;

export const Description = styled.p`
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 17px;

  ${media.tabletL`
    font-size: 18px;
    margin-bottom: 70px;
  `};
`;

export const Input = styled.input`
  width: 100%;
  max-width: 335px;
  border: none;
  border-bottom: 2px solid ${({ error }) => (error ? '#b8193f' : '#000')};
  font-size: 18px;
  font-weight: 400;
  line-height: 1.2em;
  padding: 13px 0;
`;

export const InputSubtitle = styled.p`
  display: none;

  ${media.tabletL`
    display: block;
  `};
`;

export const ErrorText = styled.p`
  font-size: 12px;
  color: #b8193f;
  letter-spacing: 1px;
  margin-top: 10px;
`;



// WEBPACK FOOTER //
// ./src/pages/HairDiagnosisPage/Slides/Name.style.js